import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/hw-clock-in/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/hw-clock-in',
  name: 'activity_hw_clock_in',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '完成体育作业 领S+会员',
  },
}

export default [indexRoute]
